import classNames from 'classnames'

import { EVENT_NAME_SCROLL } from '../../../constants/event'
import { SIZE } from '../../../constants/size'
import { useContentEdgesShadow, useEventListener } from '../../../hooks'

import * as styles from './Content.module.css'

function Content({
  children,
  className,
  containerClassName,
  contentRef,
  contentWrapperClassName = styles.contentWrapper,
  contentWrapperRef,
  isFullScreen,
  ref,
  shadow,
  size = SIZE.MEDIUM,
  onScroll,
}) {
  useEventListener({
    elementRef: contentRef,
    eventName: EVENT_NAME_SCROLL,
    handler: onScroll,
  })

  const {
    bottomEndIntersectionElement,
    shadowElement,
    topEndIntersectionElement,
  } = useContentEdgesShadow({ shadow })

  const contentClassName = classNames(
    styles.content,
    styles[`${size}Size`],
    {
      [styles.fullScreen]: isFullScreen,
    },
    className
  )

  const containerStyles = classNames(
    styles.container,
    styles[`${size}ContainerSize`],
    containerClassName
  )

  return (
    <div className={containerStyles} ref={ref}>
      <div className={contentClassName} ref={contentRef}>
        <div className={contentWrapperClassName} ref={contentWrapperRef}>
          {topEndIntersectionElement}
          {bottomEndIntersectionElement}
          {children}
        </div>
      </div>
      {shadowElement}
    </div>
  )
}

export { Content }
